import { CreateMUIStyled, css as muiCss, styled as muiStyled, Theme } from '@mui/material/styles'

export const styled: CreateMUIStyled<Theme> = muiStyled
export const css = muiCss
